const getters = {
    employee: (state) => state.employee,
    subordinate: (state) => state.subordinate,
    loading: state => state.loading
};

export default getters;